import { createSlice, PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit';
import { SliceName } from '../../name';
import { BookingReducerProps } from './type';
import { bookingThunkReducers } from './thunks';
import { RestaurantReservation } from '@core/models';

const bookingSlice = createSlice<
  BookingReducerProps,
  SliceCaseReducers<BookingReducerProps>,
  string
>({
  name: SliceName.Booking,
  initialState: {
    isLoading: true,
    bookingSetting: null,
    reservations: [],
  },
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
      return state;
    },
    setBookingState: (state, action: PayloadAction<BookingReducerProps>) => {
      state = action.payload;
      return state;
    },
    setRestaurantReservations: (state, action: PayloadAction<RestaurantReservation[]>) => {
      state.reservations = action.payload;
      return state;
    },
  },
  extraReducers: bookingThunkReducers,
});

export const { setBookingState, setRestaurantReservations } = bookingSlice.actions;
export const bookingReducer = bookingSlice.reducer;
